import React from 'react';
import styled from 'styled-components';
import ButtonIcon from '@pedidosya/web-fenix/system/ButtonIcon';
import ChevronLeft from '@pedidosya/web-fenix/icons/ChevronLeft';
import TitleM from '@pedidosya/web-fenix/system/TitleM';
import useIsDesktop from '@/src/hooks/useIsDesktopLayout';
import { getSpacing } from '@/src/utils/styles/fenixHelpers';
import MobileHeader from './components/MobileHeader';

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: ${getSpacing(8, 4, 6, 0)};
`;

const DesktopTitle = ({ title = '', showBack = true, onBack = () => {} }) => (
  <Container data-testid="desktop-title">
    {showBack && (
      <ButtonIcon
        aria-label="Regresar"
        icon={<ChevronLeft />}
        size="medium"
        withStroke={false}
        onClick={onBack}
      />
    )}
    {!!title && <TitleM titleValue={title} />}
  </Container>
);

const PageTitle = ({
  title,
  showBack,
  withMobileMarginBottom = false,
  onBack,
}) => {
  const isDesktop = useIsDesktop();

  return isDesktop ? (
    <DesktopTitle title={title} showBack={showBack} onBack={onBack} />
  ) : (
    <MobileHeader
      title={title}
      showBack={showBack}
      onBack={onBack}
      withMarginBottom={withMobileMarginBottom}
    />
  );
};

export default PageTitle;
